var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.editable)?_c('vs-textarea',{staticClass:"mb-3",attrs:{"value":_vm.value,"rows":"4","aria-label":_vm.accessibleLabel},on:{"input":_vm.handleInput}}):_c('p',{staticClass:"my-5"},[_vm._v(_vm._s(_vm.value ? _vm.value : 'N/A'))])}
var staticRenderFns = []

export { render, staticRenderFns }